<div style="background-color:white; margin: 0; padding-bottom: 10px;">
  <table class="gt-reclass-table table table-condensed">
    <thead style="white-space:nowrap;">
      <tr>
        <th colspan="16" style="width: 100%;">Component Defaults Rollover</th>
      </tr>
    </thead>
  </table>
  <br>

  <div class="row">
    <div class="col-md-2 col-md-offset-1">
      <label>Source Tax Year :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedTaxYear"
                (ngModelChange)="onTaxYearChange()">
          <option value="">-- Select --</option>
          @for (option of filteredTaxYearData; track $index) {
<option
                  [value]="option.CODE_DISP_DESC">
            {{ option.CODE_SHORT_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    @if (scenarioRAF.length > 0) {
<div class="col-md-2 col-md-offset-1">
      <label>Scenario :</label>
      <div>
        <select class="form-control"
                [(ngModel)]="selectedScenario"
                disabled>
          @for (option of scenarioRAF; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
      </div>
    </div>
}

    @if (loadParentMEDropdown) {
<div class="col-md-2 col-md-offset-1">
      <label>Parent ME(s) :</label>
      @if (!loading) {
<div>
        <select class="form-control"
                [(ngModel)]="selectedParentMes">
          <option value="">-- Select --</option>
          @for (p of parentMEDropDown; track $index) {
<option
                  [value]="p.PARENT_ME_KEY">
            {{ p.PARENT_ME_NAME }}
          </option>
}
        </select>
      </div>
}
      @if (loading) {
<div class="input-group">
        <input type="text" class="form-control input-sm" disabled placeholder="loading"
               style="height: 34px;">
        <span class="input-group-addon"><i class="fa fa-spinner fa-pulse"></i></span>
      </div>
}
    </div>
}
  </div>

  <br><br><br>

  <div class="row">
    <div class="col-md-3 col-md-offset-7">
      <button class="btn btn-info btn-sm" type="button"
              (click)="confirmRunComponentDefaultsRollover()">
        Run Rollover
      </button>
      &nbsp;&nbsp;&nbsp;
      <button class="btn btn-default btn-sm reset-btn-no-hover" type="button"
              (click)="reset()">
        Reset
      </button>
    </div>
  </div>
</div>

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
